export function voucherAutoAssignGroupPath(assignmentGroup: string) {
  return `/marketing/voucher-auto-assign-rules/group/${encodeURIComponent(assignmentGroup)}`;
}
